
import smdRoutes from './sub-modules/smd/routes'
import sndRoutes from './sub-modules/snd/routes'

export default [

  ...smdRoutes,
  ...sndRoutes
]
